import { useContext } from "react";
import { getRequest } from "../../../../Services/axios.service";
import { DISTRICTS, MUNICIPALITIES, PROVINCES } from "../../Utils/territories-url";
import { TerritoryContext } from "../territoryContext";

const baseUrl = process.env.REACT_APP_OGTIC_TERRITORIES

export default function useTerritory() {
    const { territories, setTerritories, loadingSet, setLoadingSet } = useContext(TerritoryContext)

    const fetchProvinces = async () => {
        setLoadingSet((cur) => ({ ...cur, provinces: true }))
        const { data } = await getRequest(PROVINCES, { baseURL: baseUrl })
        setLoadingSet((cur) => ({ ...cur, provinces: false }))
        if (data.valid) {
            setTerritories((cur) => ({ provinces: data.data }))
        }
        else {
            setTerritories((cur) => ({ provinces: [] }))
        }
        return data
    }

    const fetchMunicipalities = async (code) => {
        const params = new URLSearchParams([['provinceCode', code]])
        setLoadingSet((cur) => ({ ...cur, municipalities: true }))
        const { data } = await getRequest(MUNICIPALITIES, { baseURL: baseUrl, params })
        setLoadingSet((cur) => ({ ...cur, municipalities: false }))
        if (data.valid) {
            setTerritories((cur) => ({ ...cur, municipalities: [data.data].flat(2) }))
        }
        else {
            setTerritories((cur) => ({ ...cur, municipalities: [] }))
        }
        return data
    }

    const fetchDistricts = async (code, provinceCode) => {
        const params = new URLSearchParams([['provinceCode', provinceCode], ['municipalityCode', code]])
        setLoadingSet((cur) => ({ ...cur, districts: true }))
        const { data } = await getRequest(DISTRICTS, { baseURL: baseUrl, params })
        setLoadingSet((cur) => ({ ...cur, districts: false }))
        if (data.valid) {
            setTerritories((cur) => ({ ...cur, districts: [data.data].flat(2) }))
        }
        else {
            setTerritories((cur) => ({ ...cur, districts: [] }))
        }
        return data
    }

    return {
        territories,
        loadingSet,
        fetchProvinces,
        fetchMunicipalities,
        fetchDistricts
    }
}